import React from "react";

export default function ServiceAsideItem({ item }) {
    if (item && typeof item === "object" && !Array.isArray(item)) {
        return (
            <p>
                <strong>{item.label}</strong> — {item.text}
            </p>
        );
    }

    if (typeof item !== "string") {
        return null;
    }

    return <p>{item}</p>;
}
